import { Component, ContentChild, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent } from '@sim/form';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ui-input-repeatable',
  styleUrls: ['./input-repeatable.component.scss'],
  templateUrl: './input-repeatable.component.html',
})
export class InputRepeatableComponent extends BaseCtrlValueAccessorFormArrayComponent<any> implements OnDestroy, OnInit {

  @ContentChild(TemplateRef) inputTemplate?: TemplateRef<any>;

  get items() {
    const form = this.form && this.form.controls;
    return form || [];
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addItemHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage input without a control');
    }

    const control = new UntypedFormControl('');
    this.form.push(control);
  }

  removeItemHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage input without a control');
    }

    this.form.removeAt(index);
  }

}
